/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76454ResModelTaskGanttListItem {
  
  /** 任务节点id */
  nodeId?: string;
  
  /** 任务开始时间 */
  startTime?: string;
  
  /** 任务持续时间 */
  taskDuration?: number;
  
  /** 任务编号 */
  nodeNo?: string;
  
  /** 父节点ID ,String */
  parentNodeIds?: string[];
  
  /** 节点名称 */
  nodeName?: string;
  
  /** 节点标签 */
  nodeTag?: string;
  
  /** 节点描述 */
  nodeDesc?: string;
  
  /** 岗位 */
  role?: string;
  
  /** 触发方式,timeTarget:时间触发,nodeStart:节点开始触发,nodeEnd：节点完成触发 */
  triggerType?: string;
  
  /** 触发方式描述 */
  triggerTypeDesc?: string;
  
  /**  */
  completeTaskNeedSubmit?: string;
  
  /**  */
  completeTaskInformation?: string;
  
};
    
  
    
export interface IAPI76454ResPositionListItem {
  
  /** 岗位key */
  positionKey?: string;
  
  /** 岗位名称 */
  positionName?: string;
  
};
    
  



export interface API76454Req {
  
  /** 任务模型id */
  dataId?: string;
    
  /** 版本号 */
  version?: string;
    
};



export interface API76454Res {
  /** 模型id  */
  dataId?: string;
  /** 模型名称  */
  modelTaskName?: string;
  /** 模型描述  */
  modelTaskDesc?: string;
  /** 模型版本号  */
  newVersion?: number;
  /** 节点信息 ,ModelTaskGanttResp  */
  modelTaskGanttList?: IAPI76454ResModelTaskGanttListItem[];
  /** 岗位key ,TaskPositionResult  */
  positionList?: IAPI76454ResPositionListItem[];
  
};


// 接口函数 76454 查看任务甘特图

export interface IUseGetAPI76454Return {
  /** 查看任务甘特图: 接口请求状态 */
  isAPI76454Loading: boolean;
  /** 查看任务甘特图: 接口请求返回数据 */
  dataAPI76454: API76454Res;
  /**  查看任务甘特图: 接口数据请求方法 */
  fetchAPI76454Data: (inputs: API76454Req, config?: YWRequestConfig) => Promise<API76454Res>;
  /** 查看任务甘特图: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76454 = ():IUseGetAPI76454Return => {
  let isMount = true;
  const [isAPI76454Loading, setIsAPI76454Loading] = useState(false);
  const [dataAPI76454, setDataAPI76454] = useState<API76454Res>({} as API76454Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/task/model/view/model`;

  const fetchAPI76454Data = async (inputs: API76454Req, config?: YWRequestConfig): Promise<API76454Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76454Req>) || {}) as API76454Req;
    
  
    if ( isMount ) {
      setIsAPI76454Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76454Res>(`${basePath}/yoaichat-web/chat/task/model/view/model?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76454(res || {} as API76454Res);
        setIsAPI76454Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76454Loading(false);
      }
      return false as unknown as API76454Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76454Loading,
    dataAPI76454,
    fetchAPI76454Data,
    requestUrl,
  }
}

